const domestic_lending = {
  title: 'You’re eligible to apply, but not for the school that you’ve selected',
  body:
    'As an international lender, we primarily support students intending to study abroad. If you are considering other schools, please submit another application.',
};

const part_time = {
  title: 'A full-time job is required to apply for the part-time course you selected',
  body:
    "As a responsible lender, it’s very important to us that you're able to afford your repayments while you study part-time. For that reason, we require you to have a full-time job and to continue working during your study.\n\nIf your circumstances change, you are welcome to submit another application.",
};

const school = {
  title: 'Unfortunately we are not able to support your chosen school',
  body:
    "To comply with applicable laws and our funding partners' terms, we apply certain eligibility criteria to select schools that we can support. Unfortunately, your chosen school is not one of them.\n\nIf you are considering other schools, please submit another application.",
};

const plan = {
  title: 'Unfortunately we are unable to support your study plan',
  body:
    "To comply with applicable laws and our funding partners' terms, we apply certain eligibility criteria when evaluating all our loan applications. Based on what you've submitted, unfortunately you're not eligible to apply for our loans.",
};

export const changedResponse = {
  domestic_lending,
  part_time,
  school,
  plan,
};
